export const takeSurveyLanguages = [
  { value: 'English', viewValue: 'English' },
  { value: 'Hindi', viewValue: 'हिंदी' },
  { value: 'Assamese', viewValue: 'অসমীয়া' },
  { value: 'Bengali', viewValue: 'বাংলা' },
  { value: 'Gujrati', viewValue: 'ગુજરાતી' },
  { value: 'Kannada', viewValue: 'ಕನ್ನಡ' },
  { value: 'Malayalam', viewValue: 'മലയാളം' },
  { value: 'Marathi', viewValue: 'मराठी' },
  { value: 'Odia', viewValue: 'ଓଡ଼ିଆ' },
  { value: 'Punjabi', viewValue: 'ਪੰਜਾਬੀ' },
  { value: 'Tamil', viewValue: 'தமிழ்' },
  { value: 'Telugu', viewValue: 'తెలుగు' },
  { value: 'Urdu', viewValue: 'اردو' },
  { value: 'Kashmiri', viewValue: 'کٲشُر' },
  { value: 'Manipuri', viewValue: 'ꯃꯤꯇꯩꯂꯣꯟ' }
];

export const addUpdateSurveyLanguages = [
  { value: 'English', viewValue: 'English' },
  { value: 'Hindi', viewValue: 'Hindi' },
  { value: 'Assamese', viewValue: 'Assamese' },
  { value: 'Bengali', viewValue: 'Bengali' },
  { value: 'Gujrati', viewValue: 'Gujrati' },
  { value: 'Kannada', viewValue: 'Kannada' },
  { value: 'Malayalam', viewValue: 'Malayalam' },
  { value: 'Marathi', viewValue: 'Marathi' },
  { value: 'Odia', viewValue: 'Odia' },
  { value: 'Punjabi', viewValue: 'Punjabi' },
  { value: 'Tamil', viewValue: 'Tamil' },
  { value: 'Telugu', viewValue: 'Telugu' },
  { value: 'Urdu', viewValue: 'Urdu' },
  { value: 'Kashmiri', viewValue: 'Kashmiri' },
  { value: 'Manipuri', viewValue: 'Manipuri' }
];

export const hardCodedQuestionYesOptions1 = [
  // Strongly Disagree
  { text: 'Strongly Disagree', language: 'English', value: 'Strongly Disagree' },
  { text: 'पूर्णतः असहमत', language: 'Hindi', value: 'Strongly Disagree' },
  { text: 'সম্পূৰ্ণ অসম্মত', language: 'Assamese', value: 'Strongly Disagree' },
  { text: 'সম্পূর্ণ অসম্মত', language: 'Bengali', value: 'Strongly Disagree' },
  { text: 'સંપૂર્ણ અસહમત', language: 'Gujrati', value: 'Strongly Disagree' },
  { text: 'ಸಂಪೂರ್ಣ ಅಸಮ್ಮತಿ', language: 'Kannada', value: 'Strongly Disagree' },
  { text: 'പൂർണ്ണമായും അസമ്മതിക്കുന്നു', language: 'Malayalam', value: 'Strongly Disagree' },
  { text: 'पूर्णपणे असहमत', language: 'Marathi', value: 'Strongly Disagree' },
  { text: 'ସମ୍ପୂର୍ଣ୍ଣ ଅସମ୍ମତ', language: 'Odia', value: 'Strongly Disagree' },
  { text: 'ਪੂਰੀ ਤਰ੍ਹਾਂ ਅਸਹਿਮਤ', language: 'Punjabi', value: 'Strongly Disagree' },
  { text: 'முற்றிலும் ஏற்கவில்லை', language: 'Tamil', value: 'Strongly Disagree' },
  { text: 'పూర్తిగా అసమ్మతి', language: 'Telugu', value: 'Strongly Disagree' },
  { text: 'مکمل اختلاف', language: 'Urdu', value: 'Strongly Disagree' },
  { text: 'پوری طرح اتفاق نہٕ', language: 'Kashmiri', value: 'Strongly Disagree' },
  { text: 'ꯌꯥꯝꯅ ꯌꯥꯔꯣꯏ', language: 'Manipuri', value: 'Strongly Disagree' },

  // Disagree
  { text: 'Disagree', language: 'English', value: 'Disagree' },
  { text: 'असहमत', language: 'Hindi', value: 'Disagree' },
  { text: 'অসম্মত', language: 'Assamese', value: 'Disagree' },
  { text: 'অসম্মত', language: 'Bengali', value: 'Disagree' },
  { text: 'અસહમત', language: 'Gujrati', value: 'Disagree' },
  { text: 'ಅಸಮ್ಮತಿ', language: 'Kannada', value: 'Disagree' },
  { text: 'അസമ്മതിക്കുന്നു', language: 'Malayalam', value: 'Disagree' },
  { text: 'असहमत', language: 'Marathi', value: 'Disagree' },
  { text: 'ଅସମ୍ମତ', language: 'Odia', value: 'Disagree' },
  { text: 'ਅਸਹਿਮਤ', language: 'Punjabi', value: 'Disagree' },
  { text: 'ஏற்கவில்லை', language: 'Tamil', value: 'Disagree' },
  { text: 'అసమ్మతి', language: 'Telugu', value: 'Disagree' },
  { text: 'اختلاف', language: 'Urdu', value: 'Disagree' },
  { text: 'اتفاق نہٕ', language: 'Kashmiri', value: 'Disagree' },
  { text: 'ꯌꯥꯔꯣꯏ', language: 'Manipuri', value: 'Disagree' },

  // Neither Agree nor Disagree
  { text: 'Neither Agree nor Disagree', language: 'English', value: 'Neither Agree nor Disagree' },
  { text: 'न सहमत न असहमत', language: 'Hindi', value: 'Neither Agree nor Disagree' },
  { text: 'সহমতও নহয় অসম্মতও নহয়', language: 'Assamese', value: 'Neither Agree nor Disagree' },
  { text: 'না সম্মত না অসম্মত', language: 'Bengali', value: 'Neither Agree nor Disagree' },
  { text: 'ના સહમત ના અસહમત', language: 'Gujrati', value: 'Neither Agree nor Disagree' },
  { text: 'ಒಪ್ಪಲೂ ಇಲ್ಲ ವಿರೋಧವೂ ಇಲ್ಲ', language: 'Kannada', value: 'Neither Agree nor Disagree' },
  { text: 'യോജിപ്പുമില്ല അസമ്മതവും ഇല്ല', language: 'Malayalam', value: 'Neither Agree nor Disagree' },
  { text: 'ना सहमत ना असहमत', language: 'Marathi', value: 'Neither Agree nor Disagree' },
  { text: 'ନ ସମ୍ମତ ନ ଅସମ୍ମତ', language: 'Odia', value: 'Neither Agree nor Disagree' },
  { text: 'ਨਾ ਸਹਿਮਤ ਨਾ ਅਸਹਿਮਤ', language: 'Punjabi', value: 'Neither Agree nor Disagree' },
  { text: 'ஏற்றும் இல்லை மறுப்பும் இல்லை', language: 'Tamil', value: 'Neither Agree nor Disagree' },
  { text: 'అంగీకారం కాదు అసమ్మతి కాదు', language: 'Telugu', value: 'Neither Agree nor Disagree' },
  { text: 'نہ متفق نہ غیر متفق', language: 'Urdu', value: 'Neither Agree nor Disagree' },
  { text: 'نہٕ اتفاق نہٕ اختلاف', language: 'Kashmiri', value: 'Neither Agree nor Disagree' },
  { text: 'ꯌꯥꯔꯣꯏ ꯑꯃꯁꯨꯡ ꯌꯥꯔꯣꯏꯗꯦ', language: 'Manipuri', value: 'Neither Agree nor Disagree' },

  // Agree
  { text: 'Agree', language: 'English', value: 'Agree' },
  { text: 'सहमत', language: 'Hindi', value: 'Agree' },
  { text: 'সহমত', language: 'Assamese', value: 'Agree' },
  { text: 'সম্মত', language: 'Bengali', value: 'Agree' },
  { text: 'સહમત', language: 'Gujrati', value: 'Agree' },
  { text: 'ಒಪ್ಪಿಗೆ', language: 'Kannada', value: 'Agree' },
  { text: 'യോജിക്കുന്നു', language: 'Malayalam', value: 'Agree' },
  { text: 'सहमत', language: 'Marathi', value: 'Agree' },
  { text: 'ସମ୍ମତ', language: 'Odia', value: 'Agree' },
  { text: 'ਸਹਿਮਤ', language: 'Punjabi', value: 'Agree' },
  { text: 'ஏற்கிறேன்', language: 'Tamil', value: 'Agree' },
  { text: 'అంగీకారం', language: 'Telugu', value: 'Agree' },
  { text: 'متفق', language: 'Urdu', value: 'Agree' },
  { text: 'اتفاق', language: 'Kashmiri', value: 'Agree' },
  { text: 'ꯌꯥꯔꯤ', language: 'Manipuri', value: 'Agree' },

  // Strongly Agree
  { text: 'Strongly Agree', language: 'English', value: 'Strongly Agree' },
  { text: 'पूर्णतः सहमत', language: 'Hindi', value: 'Strongly Agree' },
  { text: 'সম্পূৰ্ণ সহমত', language: 'Assamese', value: 'Strongly Agree' },
  { text: 'সম্পূর্ণ সম্মত', language: 'Bengali', value: 'Strongly Agree' },
  { text: 'સંપૂર્ણ સહમત', language: 'Gujrati', value: 'Strongly Agree' },
  { text: 'ಸಂಪೂರ್ಣ ಒಪ್ಪಿಗೆ', language: 'Kannada', value: 'Strongly Agree' },
  { text: 'പൂർണ്ണമായും യോജിക്കുന്നു', language: 'Malayalam', value: 'Strongly Agree' },
  { text: 'पूर्णपणे सहमत', language: 'Marathi', value: 'Strongly Agree' },
  { text: 'ସମ୍ପୂର୍ଣ୍ଣ ସମ୍ମତ', language: 'Odia', value: 'Strongly Agree' },
  { text: 'ਪੂਰੀ ਤਰ੍ਹਾਂ ਸਹਿਮਤ', language: 'Punjabi', value: 'Strongly Agree' },
  { text: 'முழுமையாக ஏற்கிறேன்', language: 'Tamil', value: 'Strongly Agree' },
  { text: 'పూర్తిగా అంగీకారం', language: 'Telugu', value: 'Strongly Agree' },
  { text: 'مکمل متفق', language: 'Urdu', value: 'Strongly Agree' },
  { text: 'پوری طرح اتفاق', language: 'Kashmiri', value: 'Strongly Agree' },
  { text: 'ꯌꯥꯝꯅ ꯌꯥꯔꯤ', language: 'Manipuri', value: 'Strongly Agree' }
];

export const hardCodedQuestionYesOptions = [{
  'text': 'Reward & Recognition',
  'value': 'Reward & Recognition',
  'language': 'English'
},
{
  'text': 'Communication Channels(upward & downward)',
  'value': 'Communication Channels(upward & downward)',
  'language': 'English'
},
{
  'text': 'Transparency',
  'value': 'Transparency',
  'language': 'English'
},
{
  'text': 'Clear & laid down processes & systems',
  'value': 'Clear & laid down processes & systems',
  'language': 'English'
},
{
  'text': 'Teamwork & Coordination',
  'value': 'Teamwork & Coordination',
  'language': 'English'
},
{
  'text': 'Flexibility & Adaptability',
  'value': 'Flexibility & Adaptability',
  'language': 'English'
},
{
  'text': 'Trust & Empowerment',
  'value': 'Trust & Empowerment',
  'language': 'English'
},
{
  'text': 'Learning & Development',
  'value': 'Learning & Development',
  'language': 'English'
},
{
  'text': 'Diversity & Inclusion',
  'value': 'Diversity & Inclusion',
  'language': 'English'
},
{
  'text': 'Others',
  'value': 'Others',
  'language': 'English'
},





{
  'text': 'रिवार्ड और मान्यता (Reward & Recognition)',
  'value': 'Reward & Recognition',
  'language': 'Hindi'
},
{
  'text': 'संचार चैनल्स (ऊपर और नीचे) (Communication Channels (upward & downward))',
  'value': 'Communication Channels(upward & downward)',
  'language': 'Hindi'
},
{
  'text': 'पारदर्शिता (Transparency)',
  'value': 'Transparency',
  'language': 'Hindi'
},
{
  'text': 'स्पष्ट और निर्धारित प्रक्रियाएं और लक्षण (Clear & laid down processes & systems)',
  'value': 'Clear & laid down processes & systems',
  'language': 'Hindi'
},
{
  'text': 'टीम वर्क और समन्वय (Teamwork & Coordination)',
  'value': 'Teamwork & Coordination',
  'language': 'Hindi'
},
{
  'text': 'लचीलापन और अनुकूलनशीलता (Flexibility & Adaptability)',
  'value': 'Flexibility & Adaptability',
  'language': 'Hindi'
},
{
  'text': 'विश्वास और सशक्तीकरण (Trust & Empowerment)',
  'value': 'Trust & Empowerment',
  'language': 'Hindi'
},
{
  'text': 'शिक्षण और विकास (Learning & Development)',
  'value': 'Learning & Development',
  'language': 'Hindi'
},
{
  'text': 'विविधता और समावेशन (Diversity & Inclusion)',
  'value': 'Diversity & Inclusion',
  'language': 'Hindi'
},
{
  'text': 'अन्य (Others)',
  'value': 'Others',
  'language': 'Hindi'
},



{
  'text': 'पुरस्कार आणि प्रशंसा (Reward & Recognition)',
  'value': 'Reward & Recognition',
  'language': 'Marathi'
},
{
  'text': 'संवाद प्रक्रिया (वरच्या आणि खालच्या दिशेने) (Communication Channels (upward & downward))',
  'value': 'Communication Channels(upward & downward)',
  'language': 'Marathi'
},
{
  'text': 'पारदर्शकता (Transparency)',
  'value': 'Transparency',
  'language': 'Marathi'
},
{
  'text': 'सुस्पष्ट आणि निर्धारित प्रोसेस आणि सिस्टम (Clear & laid down processes & systems)',
  'value': 'Clear & laid down processes & systems',
  'language': 'Marathi'
},
{
  'text': 'टीम वर्क आणि समन्वय (Teamwork & Coordination)',
  'value': 'Teamwork & Coordination',
  'language': 'Marathi'
},
{
  'text': 'लवचिकता आणि परिस्थितीनुरूप बदलाव(Flexibility & Adaptability)',
  'value': 'Flexibility & Adaptability',
  'language': 'Marathi'
},
{
  'text': 'विश्वास आणि सशक्तीकरण(Trust & Empowerment)',
  'value': 'Trust & Empowerment',
  'language': 'Marathi'
},
{
  'text': 'शिक्षण आणि विकास(Learning & Development)',
  'value': 'Learning & Development',
  'language': 'Marathi'
},
{
  'text': 'विविधता आणि समावेश(Diversity & Inclusion)',
  'value': 'Diversity & Inclusion',
  'language': 'Marathi'
},
{
  'text': 'इतर (Others)',
  'value': 'Others',
  'language': 'Marathi'
},





{
  'text': 'ಪುರಸ್ಕಾರ ಮತ್ತು ಮನ್ನಣೆ (Reward & Recognition)',
  'value': 'Reward & Recognition',
  'language': 'Kannada'
},
{
  'text': 'ಸಂವಹನ ಚಾನೆಲ್‌ಗಳು (ಮೇಲ್ಮುಖ ಮತ್ತು ಕೆಳಮುಖ)(Communication Channels (upward & downward))',
  'value': 'Communication Channels(upward & downward)',
  'language': 'Kannada'
},
{
  'text': 'ಪಾರದರ್ಶಕತೆ (Transparency)',
  'value': 'Transparency',
  'language': 'Kannada'
},
{
  'text': 'ಸ್ಪಷ್ಟ ಮತ್ತು ನಿಗದಿಸಿದ ಪ್ರಕ್ರಿಯೆಗಳು ಮತ್ತು ಸಿಸ್ಟಮ್‌ಗಳು (Clear & laid down processes & systems)',
  'value': 'Clear & laid down processes & systems',
  'language': 'Kannada'
},
{
  'text': 'ತಂಡದ ಕೆಲಸ ಮತ್ತು ಸಹಕಾರ (Teamwork & Coordination)',
  'value': 'Teamwork & Coordination',
  'language': 'Kannada'
},
{
  'text': 'ಫ್ಲೆಕ್ಸಿಬಿಲಿಟಿ ಮತ್ತು ಅಳವಡಿಸಿಕೊಳ್ಳುವಿಕೆ (Flexibility & Adaptability)',
  'value': 'Flexibility & Adaptability',
  'language': 'Kannada'
},
{
  'text': 'ವಿಶ್ವಾಸ ಮತ್ತು ಸಬಲೀಕರಣ (Trust & Empowerment)',
  'value': 'Trust & Empowerment',
  'language': 'Kannada'
},
{
  'text': 'ಕಲಿಕೆ ಮತ್ತು ಅಭಿವೃದ್ಧಿ (Learning & Development)',
  'value': 'Learning & Development',
  'language': 'Kannada'
},
{
  'text': 'ವೈವಿಧ್ಯತೆ ಮತ್ತು ಸಮಗ್ರತೆ (Diversity & Inclusion)',
  'value': 'Diversity & Inclusion',
  'language': 'Kannada'
},
{
  'text': 'ಇತರೆ (Others)',
  'value': 'Others',
  'language': 'Kannada'
},



{
  'text': 'ரிவார்டு & அங்கீகாரம் (Reward & Recognition)',
  'value': 'Reward & Recognition',
  'language': 'Tamil'
},
{
  'text': 'தொடர்பு சேனல்கள் (அனுப்புதல் மற்றும் பெறுதல்) (Communication Channels (upward & downward))',
  'value': 'Communication Channels(upward & downward)',
  'language': 'Tamil'
},
{
  'text': 'வெளிப்படைத்தன்மை (Transparency)',
  'value': 'Transparency',
  'language': 'Tamil'
},
{
  'text': 'சீர் செய்து செயல்முறைகள் மற்றும் அமைப்புகளை நிறுவுதல் (Clear & laid down processes & systems)',
  'value': 'Clear & laid down processes & systems',
  'language': 'Tamil'
},
{
  'text': 'குழுப்பணி மற்றும் ஒருங்கிணைப்பு (Teamwork & Coordination)',
  'value': 'Teamwork & Coordination',
  'language': 'Tamil'
},
{
  'text': 'நெகிழ்வுத்தன்மை மற்றும் தகவமைப்பு (Flexibility & Adaptability)',
  'value': 'Flexibility & Adaptability',
  'language': 'Tamil'
},
{
  'text': 'நம்பிக்கை மற்றும் அதிகாரம் (Trust & Empowerment)',
  'value': 'Trust & Empowerment',
  'language': 'Tamil'
},
{
  'text': 'கற்றல் மற்றும் மேம்பாடு (Learning & Development)',
  'value': 'Learning & Development',
  'language': 'Tamil'
},
{
  'text': 'பன்முகத்தன்மை மற்றும் சேர்க்கை (Diversity & Inclusion)',
  'value': 'Diversity & Inclusion',
  'language': 'Tamil'
},
{
  'text': 'மற்றவைகள் (Others)',
  'value': 'Others',
  'language': 'Tamil'
},




{
  'text': 'రివార్డు మరియు గుర్తింపు (Reward & Recognition)',
  'value': 'Reward & Recognition',
  'language': 'Telugu'
},
{
  'text': 'కమ్యూనికేషన్ చానల్స్ (పైకి మరియు కిందకు) (Communication Channels (upward & downward))',
  'value': 'Communication Channels(upward & downward)',
  'language': 'Telugu'
},
{
  'text': 'పారదర్శకత (Transparency)',
  'value': 'Transparency',
  'language': 'Telugu'
},
{
  'text': 'స్పష్టమైన మరియు పొందుపరిచిన ప్రక్రియలు మరియు వ్యవస్థలు (Clear & laid down processes & systems)',
  'value': 'Clear & laid down processes & systems',
  'language': 'Telugu'
},
{
  'text': 'సమిష్టి క్రుషి మరియు సమన్వయం (Teamwork & Coordination)',
  'value': 'Teamwork & Coordination',
  'language': 'Telugu'
},
{
  'text': 'ఫ్లెక్సిబిలిటి మరియు అడాప్టబిలిటి (Flexibility & Adaptability)',
  'value': 'Flexibility & Adaptability',
  'language': 'Telugu'
},
{
  'text': 'విశ్వాసం మరియు సాధికారికత (Trust & Empowerment)',
  'value': 'Trust & Empowerment',
  'language': 'Telugu'
},
{
  'text': 'నేర్చుకొనుట మరియు అభివ్రుద్ధి (Learning & Development)',
  'value': 'Learning & Development',
  'language': 'Telugu'
},
{
  'text': 'వైవిధ్యం మరియు ఇన్ క్లూజన్ (Diversity & Inclusion)',
  'value': 'Diversity & Inclusion',
  'language': 'Telugu'
},
{
  'text': 'ఇతరవి (Others)',
  'value': 'Others',
  'language': 'Telugu'
},



{
  'text': 'ਇਨਾਮ ਅਤੇ ਸਨਮਾਨ',
  'value': 'Reward & Recognition',
  'language': 'Punjabi'
},
{
  'text': 'ਸੰਚਾਰ ਚੈਨਲ (ਉੱਪਰਲੇ ਅਤੇ ਹੇਠਲੇ)',
  'value': 'Communication Channels(upward & downward)',
  'language': 'Punjabi'
},
{
  'text': 'ਪਾਰਦਰਸ਼ਤਾ',
  'value': 'Transparency',
  'language': 'Punjabi'
},
{
  'text': 'ਸਪਸ਼ਟ ਅਤੇ ਤੈਅ ਪ੍ਰਕਿਰਿਆਵਾਂ ਅਤੇ ਪ੍ਰਣਾਲੀਆਂ',
  'value': 'Clear & laid down processes & systems',
  'language': 'Punjabi'
},
{
  'text': 'ਟੀਮ ਵਰਕ ਅਤੇ ਸਹਿਯੋਗ',
  'value': 'Teamwork & Coordination',
  'language': 'Punjabi'
},
{
  'text': 'ਲਚੀਲਾਪਨ ਅਤੇ ਅਨੁਕੂਲਤਾ',
  'value': 'Flexibility & Adaptability',
  'language': 'Punjabi'
},
{
  'text': 'ਭਰੋਸਾ ਅਤੇ ਸਸ਼ਕਤੀਕਰਨ',
  'value': 'Trust & Empowerment',
  'language': 'Punjabi'
},
{
  'text': 'ਸਿੱਖਿਆ ਅਤੇ ਵਿਕਾਸ',
  'value': 'Learning & Development',
  'language': 'Punjabi'
},
{
  'text': 'ਵਿਭਿੰਨਤਾ ਅਤੇ ਸ਼ਾਮਿਲਤਾ',
  'value': 'Diversity & Inclusion',
  'language': 'Punjabi'
},
{
  'text': 'ਹੋਰ',
  'value': 'Others',
  'language': 'Punjabi'
}

];


export const buttonLanguageText = {
  "English": {
    "startButton": "Click here to Start",
    "submitButton": "Submit"
  },
  "Hindi": {
    "startButton": "प्रारंभ करने के लिए यहाँ क्लिक करें",
    "submitButton": "जमा करें"
  },
  "Assamese": {
    "startButton": "আৰম্ভ কৰিবলৈ ইয়াত ক্লিক কৰক",
    "submitButton": "জমা দিয়ক"
  },
  "Bengali": {
    "startButton": "শুরু করতে এখানে ক্লিক করুন",
    "submitButton": "জমা দিন"
  },
  "Gujrati": {
    "startButton": "શરૂ કરવા માટે અહીં ક્લિક કરો",
    "submitButton": "સબમિટ કરો"
  },
  "Kannada": {
    "startButton": "ಪ್ರಾರಂಭಿಸಲು ಇಲ್ಲಿ ಕ್ಲಿಕ್ ಮಾಡಿ",
    "submitButton": "ಸಲ್ಲಿಸಿ"
  },
  "Malayalam": {
    "startButton": "ആരംഭിക്കാൻ ഇവിടെ ക്ലിക്ക് ചെയ്യുക",
    "submitButton": "സമർപ്പിക്കുക"
  },
  "Marathi": {
    "startButton": "सुरू करण्यासाठी येथे क्लिक करा",
    "submitButton": "सबमिट करा"
  },
  "Odia": {
    "startButton": "ଆରମ୍ଭ କରିବା ପାଇଁ ଏଠାରେ କ୍ଲିକ୍ କରନ୍ତୁ",
    "submitButton": "ଦାଖଲ କରନ୍ତୁ"
  },
  "Punjabi": {
    "startButton": "ਸ਼ੁਰੂ ਕਰਨ ਲਈ ਇੱਥੇ ਕਲਿੱਕ ਕਰੋ",
    "submitButton": "ਜਮ੍ਹਾਂ ਕਰੋ"
  },
  "Tamil": {
    "startButton": "தொடங்க இங்கே கிளிக் செய்யவும்",
    "submitButton": "சமர்ப்பிக்கவும்"
  },
  "Telugu": {
    "startButton": "ప్రారంభించడానికి ఇక్కడ క్లిక్ చేయండి",
    "submitButton": "సమర్పించండి"
  },
  "Urdu": {
    "startButton": "شروع کرنے کے لیے یہاں کلک کریں",
    "submitButton": "جمع کریں"
  },
  "Kashmiri": {
    "startButton": "شروع کرنہ خٲطرٕ یتھ کِلک کٔریو",
    "submitButton": "جمع کٔریو"
  },
   "Manipuri": {
    "startButton": "ꯍꯧꯒꯠꯅꯕ ꯑꯁꯤꯗ ꯀ꯭ꯂꯤꯛ ꯇꯧ",
    "submitButton": "ꯊꯥꯗꯣꯛꯎ"
  }
};